import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs'; // For rxjs 6
import {
  AlertController ,
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';


import { NavController } from '@ionic/angular';

type LoadingOverlay = HTMLElement & {
  present: () => Promise<void>;
  dismiss: () => Promise<boolean>;
  onDidDismiss: () => Promise<unknown>;
};

@Injectable({
  providedIn: 'root',
})
export class IonicComponentService {
  isLoading = false;
  private activeLoading: LoadingOverlay | null = null;
  private loadingPromise: Promise<LoadingOverlay> | null = null;

  alertPresented = false;
  activeCart = false;

  isBusy = false;
  shopId = 0;
  slug = '';

  

  public alertButtons = [
    {
      text: 'OPNIEUW',
      role: 'confirm',
      handler: () => {
        //this.navCtrl.navigateRoot(['./kiosk/4']);
        window.location.href = window.location.protocol + '//' + window.location.host + '/shop/' + this.shopId;
        //window.location.reload();
        this.modalController.dismiss();
      },
    },
  ];

  public cartRedirectAlertButtons = [
    {
      text: 'NIEUW TIJDSLOT KIEZEN',
      role: 'confirm',
      handler: () => {
        window.history.back();
        this.modalController.dismiss();
      },
    },
  ];

  constructor(
    private loadingController: LoadingController,
    private alertController: AlertController,
    private toastController: ToastController,
    private modalController: ModalController
  ) {}


  public async dismiss() {
    await this.safeDismissAlert();
  }

  async presentAlert(msg: string) {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: '',
      message: msg,
      //buttons: ['OK'],
      backdropDismiss​: false,
    });
    await alert.present();
  }

  async presentAlertTitle(msg: string, title: string) {
    const alert = await this.alertController.create({
      header: title,
      subHeader: '',
      message: msg,
      //buttons: ['OK'],
      backdropDismiss: false,
    });
    await alert.present();
  }

  async presentLoading() {
    return this.presentTrackedLoading({
      spinner: 'crescent',
      duration: 10000,
      //message: 'Please wait...',
      translucent: true,
      cssClass: 'loadingDialog',
      //duration: 5000,
    });
  }

  async presentLoadingMessage(msg: string) {
    return this.presentTrackedLoading({
      spinner: 'crescent',
      duration: 10000,
      message : msg,
      translucent: true,
      cssClass: 'loadingDialog',
      //duration: 5000,
    });
  }

  async presentTimeoutLoading(timeout: number, translucent: boolean) {
    return this.presentTrackedLoading({
      spinner: 'crescent',
      duration: timeout,
      //   message: 'Please wait...',
      translucent,
      cssClass: 'loadingDialog',
      //duration: 5000,
    });
  }

  async presentAlertButton(msg: string) {
    const alert = await this.alertController.create({
      header: 'Melding',
      subHeader: '',
      message: msg,
      buttons: this.alertButtons,
      backdropDismiss​: false,
    });
    await alert.present();
  }

  async presentCartRedirectAlertButton(msg: string) {
    const alert = await this.alertController.create({
      header: 'Melding',
      subHeader: '',
      message: msg,
      buttons: this.cartRedirectAlertButtons,
      cssClass: 'single-button-alert',
      backdropDismiss​: false,
    });
    await alert.present();
  }

  async dismissLoading() {
    this.isLoading = false;
    const loading = this.activeLoading || (await this.loadingController.getTop());

    if (!loading) {
      return;
    }

    try {
      await loading.dismiss();
    } catch (error) {
      if (!this.isOverlayMissingError(error)) {
        throw error;
      }
    } finally {
      if (this.activeLoading === loading) {
        this.activeLoading = null;
      }
      this.loadingPromise = null;
    }
  }

  async setShopId(id: number) {
    this.shopId = id;
  }

  async setSlug(slug: string) {
    this.slug = slug;
  }

  private async presentTrackedLoading(options: Parameters<LoadingController['create']>[0]) {
    this.isLoading = true;

    if (this.activeLoading) {
      return;
    }

    if (this.loadingPromise) {
      await this.loadingPromise;
      return;
    }

    this.loadingPromise = this.loadingController.create(options);
    const loading = await this.loadingPromise;
    this.activeLoading = loading;

    loading.onDidDismiss().then(() => {
      if (this.activeLoading === loading) {
        this.activeLoading = null;
      }
      if (this.loadingPromise) {
        this.loadingPromise = null;
      }
    });

    try {
      await loading.present();
      if (!this.isLoading) {
        await this.dismissLoading();
      }
    } catch (error) {
      this.activeLoading = null;
      this.loadingPromise = null;
      if (!this.isOverlayMissingError(error)) {
        throw error;
      }
    }
  }

  private async safeDismissAlert() {
    const alert = await this.alertController.getTop();

    if (!alert) {
      return;
    }

    try {
      await alert.dismiss();
    } catch (error) {
      if (!this.isOverlayMissingError(error)) {
        throw error;
      }
    }
  }

  private isOverlayMissingError(error: unknown): boolean {
    return error instanceof Error && error.message.includes('overlay does not exist');
  }
}
